import React from 'react';
import '../styles/NivoraAppShell.css';
import ThemeToggle from './ThemeToggle';

export function resolveNavbarTenantName(user, branding) {
  const centralTenantName = String(
    user?.central_tenant_name
      || user?.tenant?.name
      || user?.tenant?.displayName
      || ''
  ).trim();
  const centralTenantSlug = String(user?.central_tenant_slug || '').trim();
  const brandingName = String(branding?.displayName || '').trim();
  const centralSession = Boolean(user?.central_tenant_id)
    || ['central', 'offline_signed'].includes(String(user?.session_mode || ''));

  return centralSession
    ? (centralTenantName || brandingName || centralTenantSlug)
    : (brandingName || centralTenantName || centralTenantSlug);
}

export default function Navbar({ user, branding, onLogout, menuOpen = false, onMenuToggle }) {
  const nivoraLogo = `${process.env.PUBLIC_URL || ''}/assets/nivora-logo.png`;
  const roleLabel = {
    owner: 'Owner',
    admin: 'Administrador',
    colaborador: 'Colaborador',
    vendedor: 'Vendedor',
    entregador: 'Entregador',
    contador: 'Contador'
  }[user?.perfil_acesso || user?.cargo] || user?.cargo;
  const displayName = String(user?.nome || user?.username || 'Usuário');
  const initials = displayName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
  const tenantName = resolveNavbarTenantName(user, branding);
  const offline = String(user?.session_mode || '').startsWith('offline');

  return (
    <header className="navbar">
      <div className="navbar-brand-group">
        <button
          type="button"
          className="navbar-menu-button"
          aria-label={menuOpen ? 'Fechar menu principal' : 'Abrir menu principal'}
          aria-expanded={menuOpen}
          onClick={onMenuToggle}
        >
          <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
        <div className="navbar-brand">
          <span className="navbar-nivora-logo">
            <img src={nivoraLogo} alt="Nivora ERP" />
          </span>
          <span className="navbar-workspace-context">
            <span className="navbar-workspace-icon" aria-hidden="true">
              <i className="fas fa-th-large"></i>
            </span>
            <span>
              <small>Central operacional</small>
              <strong>Painel de gestão</strong>
            </span>
          </span>
          {tenantName && (
            <span className="navbar-tenant-context" title={tenantName}>
              {branding?.logoDataUrl && (
                <span className="navbar-tenant-logo">
                  <img src={branding.logoDataUrl} alt="" aria-hidden="true" />
                </span>
              )}
              <span>
                <small>Operação atual</small>
                <strong>{tenantName}</strong>
              </span>
            </span>
          )}
        </div>
      </div>
      <div className="navbar-user">
        <span
          className={`navbar-connection ${offline ? 'is-offline' : 'is-online'}`}
          aria-label={`Conexão: ${offline ? 'offline' : 'online'}`}
        >
          <i aria-hidden="true"></i>
          {offline ? 'Offline' : 'Online'}
        </span>
        <span className="navbar-user-avatar" aria-hidden="true">{initials || 'U'}</span>
        <span className="navbar-user-copy">
          <strong className="navbar-user-name">{displayName}</strong>
          <small>{roleLabel || 'Usuário'}</small>
        </span>
        <ThemeToggle />
        <button
          type="button"
          className="navbar-logout-button"
          onClick={onLogout}
          aria-label="Sair do Nivora ERP"
          title="Sair"
        >
          <i className="fas fa-sign-out-alt" aria-hidden="true"></i>
          <span>Sair</span>
        </button>
      </div>
    </header>
  );
}
